import { render, staticRenderFns } from "./CreateAccountModal.vue?vue&type=template&id=6fd495ce&scoped=true"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountModal.vue?vue&type=style&index=0&id=6fd495ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd495ce",
  null
  
)

export default component.exports